import {TranslateService} from "@ngx-translate/core";

export const provideTranslation = {
  provide: TranslateService,
  useFactory: () => TranslateService,
};
